import { Component, ElementRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { JProject } from '@ascschool/interface/project';
import { SideBarLink } from '@ascschool/interface/ui-model/nav-link';
import { SideBarLinks } from '@ascschool/project/config/sidebar';
import { ProjectQuery } from '@ascschool/project/state/project/project.query';
import { TabService } from '@ascschool/project/tabs/tab.service';
import { Tab } from '@ascschool/project/tabs/tab.model';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { SearchDrawerComponent } from '../../search/search-drawer/search-drawer.component';
import { SettingDrawerComponent } from '../../menu-drawer/setting-drawer/setting-drawer.component';
import { formatDistance, addDays } from 'date-fns';
import { JUser } from '@ascschool/interface/user';
import { SettingSchoolComponent } from '../../menu-drawer/setting-school/setting-school.component';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { SideBarService } from '../../../../services/sidebar.service';
import { ThongTinNguoiDungComponent } from '@ascschool/project/pages/thong-tin-tai-khoan/thong-tin-nguoi-dung/thong-tin-nguoi-dung.component';
import { DoiMatKhauComponent } from '@ascschool/project/pages/thong-tin-tai-khoan/doi-mat-khau/doi-mat-khau.component';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
@UntilDestroy()
export class SidebarComponent implements OnInit {
  userInfo: JUser;
  height: number;
  items: NavItem[];
  @Input() expanded: boolean;
  userItems: NavItem[];
  get sidebarWidth(): number {
    return this.expanded ? 240 : 15;
  }
  public hasScrollbar: Boolean = false;
  project: JProject;
  sideBarLinks: SideBarLink[];
  @ViewChild('styleLeft') styleLeft: ElementRef;
  constructor(
    private _projectQuery: ProjectQuery,
    private _drawerService: NzDrawerService,
    private tabService: TabService,
    public _authService: AuthService,
    private _sideBarService: SideBarService
  ) {
    this._projectQuery.all$.pipe(untilDestroyed(this)).subscribe((project) => {
      this.project = project;
    });
  }

  ngOnInit(): void {
    this.height = window.innerHeight - 91;
    this.getSideBar();
    this.items = [
      new NavItem('search', 'Search issues', this.openSearchDrawler.bind(this)),
      new NavItem('plus', 'Create issue', this.openSettingDrawler.bind(this)),
      new NavItem('setting', 'Setting', this.openSettingDrawler.bind(this))
    ];
    this.userItems = [
      new NavItem('clear', 'Xóa bộ nhớ đệm', this._authService.clearCache.bind(this)),
      new NavItem('user', 'Thông tin người dùng', this.openPopupUserInfo.bind(this)),
      new NavItem('key', 'Đổi mật khẩu', this.openPopupChangePassword.bind(this)),
      new NavItem('setting', 'Cài đặt chung', this.openSettingDrawler.bind(this)),
      new NavItem('mail', 'Hộp thư', this.onOpenMail.bind(this))
    ];
    this.userInfo = this._authService.getUserInfo();
  }

  ngAfterViewChecked() {
    this.checkForScrollbar();
  }
  checkForScrollbar() {
    this.hasScrollbar =
      this.styleLeft.nativeElement.scrollHeight > this.styleLeft.nativeElement.clientHeight;
  }
  getSideBar() {
    this._sideBarService.getMenu().subscribe((sidebar) => {      
      this.sideBarLinks = this.list_to_tree(sidebar);
    });
  }

  list_to_tree(list) {
    let map = {},
      node,
      roots = [],
      i;
    roots.push(new SideBarLink(1, 'Trang chủ', 'dashboard', 'board', 'board', []));
    for (i = 0; i < list.length; i += 1) {
      map[list[i].idTab] = i; // initialize the map
      list[i].subTabs = []; // initialize the children
    }

    for (i = 0; i < list.length; i += 1) {
      node = list[i];
      if (node.parentId !== 0) {
        // if you have dangling branches check that map[node.ptaId] exists
        list[map[node.parentId]].subTabs.push(node);
      } else {
        roots.push(node);
      }
    }
    return roots;
  }
  openSettingSchool() {
    this._drawerService.create({
      nzContent: SettingSchoolComponent,
      nzTitle: 'Cài đặt trường',
      nzPlacement: 'right',
      nzClosable: false,
      nzWidth: 700
    });
  }
  onOpenTab(info: SideBarLink) {
    this.tabService.newTab(new Tab(info.title, info.url));
  }
  onOpenMail() {
    let mail = {
      icon: 'user',
      id: 64,
      idTab: 64,
      level: 1,
      parentId: 0,
      subTabs: [],
      title: 'Hộp thư',
      url: '/mail'
    };

    this.tabService.newTab(new Tab(mail.title, mail.url));
  }

  openSearchDrawler() {
    this._drawerService.create({
      nzContent: SearchDrawerComponent,
      nzTitle: null,
      nzPlacement: 'right',
      nzClosable: false,
      nzWidth: 500
    });
  }
  openSettingDrawler() {
    this._drawerService.create({
      nzContent: SettingDrawerComponent,
      nzTitle: '<i class="fas fa-user-cog"></i> Cài đặt chung',
      nzPlacement: 'right',
      nzClosable: false,
      nzWidth: 700
    });
  }
  openPopupUserInfo() {
    this._drawerService.create({
      nzTitle: '<i class="fas fa-user"></i> Thông tin người dùng',
      nzContent: ThongTinNguoiDungComponent,
      nzPlacement: 'right',
      nzClosable: false,
      nzWidth: 700
    });
  }
  openPopupChangePassword() {
    this._drawerService.create({
      nzTitle: '<i class="fas fa-key"></i> Cập nhật mật khẩu',
      nzContent: DoiMatKhauComponent,
      nzPlacement: 'right',
      nzClosable: false,
      nzWidth: 700
    });
  }
  onResize() {
    this.height = window.innerHeight - 91;
  }
  logout() {
    this._authService.logout();
  }
}
class NavItem {
  constructor(public icon: string, public tooltip: string, public handler: Handler) {}
}
interface Handler {
  (): void;
}
